import React from "react";
import Button from "../button/Button";
import { PLACEHOLDER } from "../../helper/constant";

const displayValue = value => {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
};

const FieldRow = ({ label, value }) => (
  <div className="form-group col-md-6 d-flex">
    <label className="fs-16 medium-text mb-0 mr-2">{label}</label>
    <div className="fs-16">{displayValue(value)}</div>
  </div>
);

const ImageField = ({ label, src }) => (
  <div className="form-group col-md-6">
    <label className="fs-16 medium-text">{label}</label>
    <div>
      <img
        src={src || PLACEHOLDER}
        alt={label}
        className="mtb-15"
        style={{
          width: "200px",
          borderRadius: "4%",
          height: "150px",
          background: "#404040",
          objectFit: "cover"
        }}
      />
    </div>
  </div>
);

const EligibilityCard = ({ eligibilityView }) => {
  if (!eligibilityView) {
    return (
      <div className="form-group col-12">
        <div className="form-control react-form-input">
          No eligibility details available.
        </div>
      </div>
    );
  }

  const isVerified = eligibilityView.verified === true;
  const cardStyle = {
    width: "100%",
    borderRadius: "8px",
    border: isVerified ? "1px solid #28a745" : "1px solid #dee2e6",
    background: isVerified ? "#f0fff4" : "#f8f9fa",
    padding: "20px"
  };

  return (
    <div className="form-group col-12">
      <div style={cardStyle}>
        <div className="d-flex justify-content-between align-items-start mb-10">
          <div>
            {isVerified && (
              <i
                className="far fa-check-circle tick-bg-color mr-10"
                style={{ fontSize: "1.5rem", verticalAlign: "middle" }}
              />
            )}
            <span className="fs-18 demi-bold-text">
              {displayValue(eligibilityView.title)}
            </span>
            {eligibilityView.subtitle ? (
              <div className="fs-14 mt-5" style={{ color: "#6c757d" }}>
                {eligibilityView.subtitle}
              </div>
            ) : null}
          </div>
          {eligibilityView.plan_status ? (
            <span
              className={`c-btn ${isVerified ? "c-success" : "c-info"}`}
              style={{
                minWidth: "auto",
                pointerEvents: "none",
                padding: "4px 12px"
              }}
            >
              <div className="fs-14 medium-text">
                {eligibilityView.plan_status}
              </div>
            </span>
          ) : null}
        </div>

        <div className="row mt-15">
          <FieldRow label="Payer:" value={eligibilityView.payer_name} />
          <FieldRow label="Plan:" value={eligibilityView.plan_name} />
          <FieldRow label="Member ID:" value={eligibilityView.member_id} />
          <FieldRow
            label="Group Number:"
            value={eligibilityView.group_number}
          />
          <FieldRow
            label="Coverage Since:"
            value={eligibilityView.coverage_since}
          />
          <FieldRow label="Plan Type:" value={eligibilityView.plan_type} />
          <FieldRow
            label="Estimated cost:"
            value={eligibilityView.estimated_copay_display}
          />
        </div>
      </div>
    </div>
  );
};

const ViewEligibility = props => {
  const { eligibilityData, toggle } = props;
  const insuranceDetails = eligibilityData?.insurance_details || {};
  const eligibilityView = eligibilityData?.eligibility_view || null;

  return (
    <div>
      <form className="pa-24 row">
        <div className="form-group col-12">
          <h5 className="fs-16 demi-bold-text mb-10">Insurance Details</h5>
        </div>
        <FieldRow
          label="Insurance Carrier:"
          value={insuranceDetails.insurance_carrier}
        />
        <FieldRow label="Member ID:" value={insuranceDetails.member_id} />
        <FieldRow label="Group ID:" value={insuranceDetails.group_id} />
        <FieldRow
          label="Primary Subscriber:"
          value={insuranceDetails.primary_subscriber}
        />
        <ImageField
          label="Front image:"
          src={insuranceDetails.front_insurance_image}
        />
        <ImageField
          label="Back image:"
          src={insuranceDetails.back_insurance_image}
        />

        <div className="form-group col-12 mt-15">
          <h5 className="fs-16 demi-bold-text mb-10">Eligibility</h5>
        </div>
        <EligibilityCard eligibilityView={eligibilityView} />

        <div className="col-12 text-center mt-15">
          <Button
            type="button"
            className="c-btn c-secondary form-button fs-16 demi-bold-text"
            style={{ maxWidth: "200px" }}
            onClick={toggle}
          >
            Close
          </Button>
        </div>
      </form>
    </div>
  );
};

export default ViewEligibility;
